var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import '../homePage/homePage.scss';
import { UuiFlexlayout } from '@aonunited/react';
import TableFilter from './tableFilter/tableFilter';
import { AgGridColumns, GetRowHeight } from './columnHeader/columnHeader';
import { postSandPRatingsData } from '../../api/marketData/sandPRatingsData';
import { postMarketFactSheet } from '../../api/marketData/marketFactSheetsData';
import { postAMBestFinsData } from '../../api/marketData/amBestFinData';
import { postAMBestRatingsData } from '../../api/marketData/amBestRatingsData';
import { postMarketGuideData } from '../../api/marketData/marketGuideData';
import { getAdvanceMarketInfo } from '../../api/marketData/advanceMarketInfo';
import { formatDate, getApplicationConfig, getDefaultHomeGridPageSize, isExternalReviewOrPreviewUser, showMarket } from '../../constants/utilities';
import { PageSize } from '../../constants/Constants';
import { getSubscribeEntities } from '../../api/marketData/apiSubscribedEntities';
import { useAppInfoStore, useClientPageStore, useErrorStore, useHomeStore, useNotificationStore } from '../../store';
import { observer } from "mobx-react";
import { getMarketProfileData } from '../../api/marketData/marketProfileData';
import { getGroupProfileData } from '../../api/marketData/groupProfileData';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getMarketSecurityBrief } from '../../api/documentDetails';
import AonAgGridTable from '../../components/core/AonAgGridTable/table';
import { getMarketDataReport } from '../../api/marketData/ExportMarketData';
import { getOktaUserEmail, isInternaluser } from '../../api/auth/okta';
import { EmailMarketData } from '../../api/marketData/EmailMarketData';
import { EmailExportedDailog } from '../Dailog/EmailExportDialog';
var HomePage = observer(function () {
    var searchParams = useSearchParams();
    var docGuid = searchParams[0].get("DocumentGuid");
    var DocType = searchParams[0].get("DocType");
    var paramsMarketId = searchParams[0].get("MarketId");
    var _a = useState(null), gridAPI = _a[0], setGridApi = _a[1];
    var homeStore = useHomeStore();
    var _b = homeStore.filterConfig, show = _b.show, columnView = _b.columnView, advanceSearch = _b.advanceSearch, quickSearch = _b.quickSearch;
    var _c = useState(false), showExportDailog = _c[0], setShowExportDailog = _c[1];
    var _d = useState(false), isAllMarketsSelected = _d[0], setIsAllMarketsSelected = _d[1];
    var _e = React.useState({
        currentPage: 1,
        totalDatacount: undefined,
        pagesize: getDefaultHomeGridPageSize(),
        year: "",
        sortColumn: "",
        sortBy: "ASC",
        isError: false,
        retry: function () { },
        searchInput: "",
        advancePayload: undefined,
        refressPage: false,
        columnView: "",
        showMarket: "",
        initialLoading: true,
    }), pageConfig = _e[0], setPageConfig = _e[1];
    var _f = React.useState([]), marketListData = _f[0], setMarketListData = _f[1];
    var _g = React.useState(true), isLoading = _g[0], setIsLoading = _g[1];
    var _h = React.useState(false), marketData = _h[0], setMarketData = _h[1];
    var appINfo = useAppInfoStore();
    var clientStore = useClientPageStore();
    var notificationStore = useNotificationStore();
    var errorStore = useErrorStore();
    var listRef = useRef(marketListData);
    var handlePageChangeRequest = function (page) {
        gridAPI === null || gridAPI === void 0 ? void 0 : gridAPI.ensureIndexVisible(0, "top");
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        page = page.detail.page;
        setPageConfig(function (prev) {
            return (__assign(__assign({}, prev), { currentPage: page }));
        });
    };
    var handleAllMarketsClick = function () {
        gridAPI === null || gridAPI === void 0 ? void 0 : gridAPI.ensureIndexVisible(0, "top");
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        setIsAllMarketsSelected(true);
        setPageConfig(function (prev) { return (__assign(__assign({}, prev), { pagesize: PageSize.ALL, currentPage: 1 })); });
    };
    var handlePagesClick = function () {
        gridAPI === null || gridAPI === void 0 ? void 0 : gridAPI.ensureIndexVisible(0, "top");
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        setIsAllMarketsSelected(false);
        setPageConfig(function (prev) { return (__assign(__assign({}, prev), { pagesize: getDefaultHomeGridPageSize(), currentPage: 1 })); });
    };
    var onSelected = function (index, isFavorite) {
        var rowData = __spreadArray([], marketListData, true);
        if (isFavorite) {
            rowData[index].isFavorite = !rowData[index].isFavorite;
        }
        else {
            rowData[index].isSubsribed = !rowData[index].isSubsribed;
        }
        setMarketListData(rowData);
    };
    useEffect(function () {
        if (appINfo.IEContactID && pageConfig.showMarket) {
            fetchHomeGridData();
        }
    }, [appINfo.IEContactID, pageConfig.showMarket, pageConfig.advancePayload, pageConfig.searchInput, pageConfig.pagesize, pageConfig.currentPage, pageConfig.sortColumn, pageConfig.sortBy]);
    var _j = useState(window.innerHeight), currentInneHeight = _j[0], setcurrentInneHeight = _j[1];
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    useEffect(function () {
        if (DocType && docGuid && getApplicationConfig().applicationId === 3) {
            initiateDocDownoad(docGuid);
        }
    }, [DocType, docGuid]);
    function initiateDocDownoad(documentGUId) {
        return __awaiter(this, void 0, void 0, function () {
            var resposne, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, getMarketSecurityBrief(documentGUId)];
                    case 1:
                        resposne = _a.sent();
                        if (!(resposne.data === true)) return [3 /*break*/, 3];
                        return [4 /*yield*/, clientStore.handlePdfDownload(documentGUId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        notificationStore.showNotification({
                            message: "Sorry! Requested Document not found.",
                            variant: "error",
                            visible: true,
                            showOkButton: true
                        });
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        console.log("Oops!! Server Error, Please try after sometime!");
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    var navigation = useNavigate();
    useEffect(function () {
        if (paramsMarketId && getApplicationConfig().applicationId === 3) {
            handleNavigation();
        }
    }, [paramsMarketId]);
    var handleNavigation = function () {
        navigation("/market-details?MarketId=" + paramsMarketId);
    };
    var getPHsandASHFValue = function (finaceData) {
        var surplusValue = 0.0;
        if (Boolean(finaceData.policyholdersSurplus.applicableToMarketFlag)) {
            surplusValue = finaceData.policyholdersSurplus.value;
        }
        else if (Boolean(finaceData.adjustedShareholdersFunds.applicableToMarketFlag)) {
            surplusValue = finaceData.adjustedShareholdersFunds.value;
        }
        else if (Boolean(finaceData.capitalSurplus.applicableToMarketFlag)) {
            surplusValue = finaceData.capitalSurplus.value;
        }
        else if (Boolean(finaceData.capacity.applicableToMarketFlag)) {
            surplusValue = finaceData.capacity.value;
        }
        else if (Boolean(finaceData.estimatedAssetsUnderManagement.applicableToMarketFlag)) {
            surplusValue = finaceData.estimatedAssetsUnderManagement.value;
        }
        var updatedSurplusValue = Number((surplusValue * finaceData.exchangeRateToUSD / 1000));
        return updatedSurplusValue;
    };
    var fetchHomeGridData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var application, quickSearch, advanceSearchPayload, isShowAllMarket, isGuideMode, isPreviewMode, getSubscribeEntitiesResponse_1, sortColumn, marketInfoPayload, allMarketIds, getAdvancedMarketInfo, levelTwoMarketId, totalCount_1, allMarketGroupIds, marketListData_1, allAPIPromises, _allAPIPromises, allResponse_1, error_2, message, status;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    application = getApplicationConfig();
                    quickSearch = pageConfig.searchInput;
                    advanceSearchPayload = pageConfig.advancePayload;
                    isShowAllMarket = pageConfig.showMarket === showMarket.all;
                    isGuideMode = application.applicationId === 3;
                    isPreviewMode = application.applicationId === 1;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 9, 10, 11]);
                    setIsLoading(true);
                    homeStore.setAPiLoading(true);
                    getSubscribeEntitiesResponse_1 = undefined;
                    if (!(!quickSearch && !advanceSearchPayload && appINfo.IEContactID && !isShowAllMarket && !isGuideMode && !isPreviewMode)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSubscribeEntities(appINfo.IEContactID, undefined, pageConfig.showMarket === showMarket.Favorite, pageConfig.showMarket === showMarket.new_subscribe)];
                case 2:
                    getSubscribeEntitiesResponse_1
                        = _e.sent();
                    if (((_a = getSubscribeEntitiesResponse_1 === null || getSubscribeEntitiesResponse_1 === void 0 ? void 0 : getSubscribeEntitiesResponse_1.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                        //setMarketListData([]);
                        if (pageConfig.initialLoading && getSubscribeEntitiesResponse_1.data.length === 0) {
                            setPageConfig(__assign(__assign({}, pageConfig), { initialLoading: false }));
                            homeStore.setFilterConfig({
                                show: showMarket.all,
                            });
                        }
                        else {
                            setMarketData(true);
                        }
                        return [2 /*return*/];
                    }
                    _e.label = 3;
                case 3:
                    sortColumn = pageConfig.sortColumn;
                    switch (sortColumn) {
                        case "MarketType":
                            sortColumn = "MarketTypeId";
                            break;
                        case "countryName":
                            sortColumn = "countryName";
                            break;
                        case "name":
                            sortColumn = "name";
                            break;
                        case "":
                            // Sort as Market ID in case of Quick serch only
                            sortColumn = quickSearch ? "marketId" : "name";
                            break;
                    }
                    marketInfoPayload = {
                        // no need to sorting at the time
                        page: pageConfig.currentPage,
                        pageSize: pageConfig.pagesize,
                        preViewReViewGuideMode: application.applicationId, //hardcoded 2 always for review home page current market list
                        isColleagueFlag: isInternaluser(), //hardcoded true always for home page current market list   //Changed on 12/02 after swati confirmed true for collegue and false for client
                    };
                    if (!isInternaluser() && application.applicationId !== 3) {
                        marketInfoPayload["accountEmail"] = getOktaUserEmail();
                    }
                    if (sortColumn && pageConfig.sortBy) {
                        marketInfoPayload = __assign(__assign({}, marketInfoPayload), { Sort: "".concat(sortColumn, " ").concat(pageConfig.sortBy) });
                    }
                    //level-two
                    if (getSubscribeEntitiesResponse_1) {
                        allMarketIds = getSubscribeEntitiesResponse_1.data.map(function (item) { return item.MarketId; });
                        marketInfoPayload["marketIds"] = allMarketIds.join(",");
                        //  clientStore.storeActiveClientsId(allMarketIds);
                    }
                    else if (advanceSearchPayload) {
                        marketInfoPayload = __assign(__assign({}, marketInfoPayload), advanceSearchPayload);
                        marketInfoPayload["preViewReViewGuideMode"] = application.applicationId; //hardcoaded for advance search in Home page
                    }
                    //else condition will execute for quick search
                    else if (quickSearch) {
                        marketInfoPayload["quickSearch"] = quickSearch;
                        marketInfoPayload["preViewReViewGuideMode"] = application.applicationId;
                    }
                    //All market drop down selected
                    if (isShowAllMarket || isGuideMode) {
                        marketInfoPayload["marketIds"] = "";
                    }
                    return [4 /*yield*/, getAdvanceMarketInfo(marketInfoPayload)];
                case 4:
                    getAdvancedMarketInfo = _e.sent();
                    if (((_c = (_b = getAdvancedMarketInfo === null || getAdvancedMarketInfo === void 0 ? void 0 : getAdvancedMarketInfo.data) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length) === 0) { //WA Rajesh
                        setMarketData(true);
                        return [2 /*return*/];
                    }
                    levelTwoMarketId = (_d = getAdvancedMarketInfo.data.value.map(function (item) { return item.marketId; })) === null || _d === void 0 ? void 0 : _d.join(",");
                    totalCount_1 = getAdvancedMarketInfo.headers["x-total-count"];
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { totalDatacount: totalCount_1 })); }); //settting up the total data count;
                    allMarketGroupIds = Array.from(new Set(getAdvancedMarketInfo.data.value.filter(function (item) { return item.marketGroupGuid; }).map(function (item) { return item.marketGroupGuid; }))).toString();
                    marketListData_1 = [];
                    if (!levelTwoMarketId) return [3 /*break*/, 8];
                    if (!((isShowAllMarket || advanceSearchPayload || quickSearch) && appINfo.IEContactID && !isGuideMode)) return [3 /*break*/, 6];
                    return [4 /*yield*/, getSubscribeEntities(appINfo.IEContactID, levelTwoMarketId, pageConfig.showMarket === showMarket.Favorite, pageConfig.showMarket === showMarket.new_subscribe)];
                case 5:
                    getSubscribeEntitiesResponse_1
                        = _e.sent();
                    _e.label = 6;
                case 6:
                    allAPIPromises = [
                        postMarketGuideData({ MarketIds: levelTwoMarketId }),
                        postAMBestRatingsData({ MarketIds: levelTwoMarketId }),
                        postAMBestFinsData({ MarketIds: levelTwoMarketId }),
                        postMarketFactSheet({ MarketIds: levelTwoMarketId }), //mapping completed
                        postSandPRatingsData({ MarketIds: levelTwoMarketId })
                    ];
                    if (application.applicationId === 2) {
                        allAPIPromises.push(getMarketProfileData({ MarketIds: levelTwoMarketId }));
                        allAPIPromises.push(getGroupProfileData({ MarketGroupGuid: allMarketGroupIds }));
                    }
                    _allAPIPromises = Promise.all(allAPIPromises);
                    return [4 /*yield*/, _allAPIPromises];
                case 7:
                    allResponse_1 = _e.sent();
                    marketListData_1 = getAdvancedMarketInfo.data.value.map(function (item) {
                        var _a;
                        var marketSubscriptionData = (_a = getSubscribeEntitiesResponse_1 === null || getSubscribeEntitiesResponse_1 === void 0 ? void 0 : getSubscribeEntitiesResponse_1.data) === null || _a === void 0 ? void 0 : _a.find(function (sitem) { return sitem.MarketId === item.marketId; });
                        var marketGuideData = allResponse_1[0].data.value.find(function (guideData) { return guideData.marketId === item.marketId; });
                        var bestRatingData = allResponse_1[1].data.value.find(function (ratingData) { return ratingData.marketId === item.marketId; });
                        var finaceData = allResponse_1[2].data.value.find(function (ratingfinData) { return ratingfinData.marketId === item.marketId; });
                        var factSheetData = allResponse_1[3].data.value.find(function (factSheetData) { return factSheetData.marketId === item.marketId; });
                        var sAndpRatingData = allResponse_1[4].data.value.find(function (sAndpRatingData) { return sAndpRatingData.marketId === item.marketId; });
                        var marketProfileData = application.applicationId === 2 ? allResponse_1[5].data.value.find(function (marketProfileData) { return marketProfileData.marketId === item.marketId; }) : undefined;
                        var groupProfileData = application.applicationId === 2 ? allResponse_1[6].data.value.find(function (groupProfileData) { return groupProfileData.marketGroupGuid === item.marketGroupGuid; }) : undefined;
                        return ({
                            marketId: item.marketId,
                            name: item.name || '',
                            groupName: item.groupName,
                            marketCategoryName: item.marketCategoryName,
                            marketTypeId: item.marketTypeId,
                            countryName: item.countryName,
                            advisoryFlag: marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.advisoryFlag,
                            advisoryDocGuid: (marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.advisoryDocGuid) || '',
                            marketGuideStatus: marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.marketGuideStatus,
                            doNotUseFlag: marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.doNotUseFlag,
                            reinsuranceIndicator: item.reinsuranceInsuranceIndicatorDesc || '',
                            permittedUse: (marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.comment) || '',
                            permittedUseToolTip: (marketGuideData === null || marketGuideData === void 0 ? void 0 : marketGuideData.comment) || '',
                            bestRating: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.bestRating,
                            ratingOutlook: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.ratingOutlook,
                            amBestId: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.amBestId,
                            amBestRatingDate: formatDate(bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.ratingDate),
                            amBestRatingExplanation: bestRatingData === null || bestRatingData === void 0 ? void 0 : bestRatingData.ratingExplanation,
                            sandPRating: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.sandPRating,
                            sAndPRatingOutlook: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.ratingOutlook,
                            sAndPId: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.sandPId,
                            sAndpRatingDate: formatDate(sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.ratingDate),
                            sAndpRatingExplanation: sAndpRatingData === null || sAndpRatingData === void 0 ? void 0 : sAndpRatingData.ratingExplanation,
                            keyFinancialAsOfDate: formatDate(finaceData === null || finaceData === void 0 ? void 0 : finaceData.keyFinancialAsOfDate),
                            surplusValue: finaceData ? getPHsandASHFValue(finaceData) : "",
                            factSheetDate: formatDate(factSheetData === null || factSheetData === void 0 ? void 0 : factSheetData.dateTimeUTCStamp),
                            factSheetDocumentGuid: factSheetData === null || factSheetData === void 0 ? void 0 : factSheetData.documentGuid,
                            marketGuid: item.marketGuid,
                            marketType: item.marketCategoryName,
                            marketTypeName: item.marketTypeName || '',
                            groupProfile: groupProfileData === null || groupProfileData === void 0 ? void 0 : groupProfileData.documentGUId,
                            marketProfile: marketProfileData === null || marketProfileData === void 0 ? void 0 : marketProfileData.documentGUId,
                            groupProfileYearQuarter: groupProfileData === null || groupProfileData === void 0 ? void 0 : groupProfileData.yearQuarter,
                            marketProfileYearQuarter: marketProfileData === null || marketProfileData === void 0 ? void 0 : marketProfileData.yearQuarter,
                            isFavorite: marketSubscriptionData ? marketSubscriptionData === null || marketSubscriptionData === void 0 ? void 0 : marketSubscriptionData.IsFavorite : undefined,
                            isSubsribed: marketSubscriptionData ? marketSubscriptionData === null || marketSubscriptionData === void 0 ? void 0 : marketSubscriptionData.IsUserSubscribedForNews : undefined,
                            InsuranceEntityId: marketSubscriptionData === null || marketSubscriptionData === void 0 ? void 0 : marketSubscriptionData.InsuranceEntityId
                        });
                    });
                    _e.label = 8;
                case 8:
                    setMarketListData(marketListData_1);
                    setMarketData(false); //wa Rajesh
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { isError: false })); });
                    return [3 /*break*/, 11];
                case 9:
                    error_2 = _e.sent();
                    console.log(error_2);
                    setMarketListData([]);
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { isError: true, retry: function () { fetchHomeGridData(); } })); });
                    message = error_2.message, status = error_2.status;
                    errorStore.showError({ message: message, code: status });
                    navigation('/error');
                    return [3 /*break*/, 11];
                case 10:
                    setIsLoading(false);
                    homeStore.setAPiLoading(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handleExportMarketData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var alldata, response, binaryString, byteArray, i, blob, link, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    alldata = listRef.current;
                    return [4 /*yield*/, getMarketDataReport({ marketIds: alldata.map(function (item) { return item.marketId; }).join(",") })];
                case 1:
                    response = _a.sent();
                    binaryString = atob(response.data.content);
                    byteArray = new Uint8Array(binaryString.length);
                    for (i = 0; i < binaryString.length; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }
                    blob = new Blob([byteArray], { type: response.data.mimeType });
                    link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = response.data.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                    notificationStore.showNotification({ message: "Market Data Exported Successfully.", variant: "success", visible: true });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.log(err_1);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [marketListData, marketListData.length]);
    var handleEmailMarketData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var alldata, allIds, res, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    alldata = listRef.current;
                    allIds = alldata.map(function (item) { return item.marketId; }).join(",");
                    console.log("handleEmailMarketData", allIds);
                    return [4 /*yield*/, EmailMarketData({ marketIds: allIds, "preViewReViewGuideMode": getApplicationConfig().applicationId })];
                case 1:
                    res = _a.sent();
                    if (res) {
                        setShowExportDailog(true);
                    }
                    else {
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.log(err_2);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [marketListData, marketListData.length]);
    useEffect(function () {
        listRef.current = marketListData;
    }, [marketListData]);
    var handleSortingFuntions = function (sortColumn) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        if (sortColumn === pageConfig.sortColumn) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: revertSortBy(pageConfig.sortBy) }));
            });
        }
        else {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: "DESC" }));
            });
        }
    };
    useEffect(function () {
        if (pageConfig.columnView !== columnView) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { searchInput: quickSearch || "", advancePayload: advanceSearch || null, columnView: columnView || "", showMarket: show || "" }));
            });
        }
        else {
            setIsAllMarketsSelected(false);
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { searchInput: quickSearch || "", advancePayload: advanceSearch || null, columnView: columnView || "", showMarket: show || "", currentPage: 1, sortColumn: "", sortBy: "ASC", pagesize: getDefaultHomeGridPageSize() }));
            });
        }
    }, [show, columnView, advanceSearch, quickSearch]);
    return (React.createElement(UuiFlexlayout, { direction: 'column', className: 'main-container' },
        React.createElement(TableFilter, { handleExportMarketData: handleExportMarketData, showMarket: pageConfig.showMarket, handleEmailMarketData: handleEmailMarketData, marketIds: marketListData.map(function (item) { return item.marketId; }).join(","), isMarketStatus: pageConfig.columnView === "MARKET_STATUS", isExportDisabled: isAllMarketsSelected, hasFactSheet: marketListData.some(function (item) { return !!item.factSheetDocumentGuid; }), hasMarketProfile: marketListData.some(function (item) { return !!item.marketProfile; }) }),
        React.createElement(AonAgGridTable, { rowData: marketData ? [] : marketListData, columns: AgGridColumns(pageConfig.columnView === "MARKET_STATUS", onSelected, pageConfig.sortColumn, pageConfig.sortBy, isLoading, handleSortingFuntions), height: currentInneHeight - 230, loading: isLoading, pagination: true, currentPage: pageConfig.currentPage, totalCount: pageConfig.totalDatacount, handleSorting: handleSortingFuntions, pageSize: pageConfig.pagesize, onPageChange: handlePageChangeRequest, RowHeightCallback: GetRowHeight, setCurrentGridAPI: setGridApi, suppressScrollOnNewData: true, showAllOption: isExternalReviewOrPreviewUser(), isAllSelected: isAllMarketsSelected, onAllClick: handleAllMarketsClick, onPagesClick: handlePagesClick, paginationMinCount: pageConfig.showMarket === showMarket.Favorite || pageConfig.showMarket === showMarket.new_subscribe ? 1 : 100 }),
        showExportDailog && React.createElement(EmailExportedDailog, { showDailog: showExportDailog, onClickClose: function () { return setShowExportDailog(false); } })));
});
export default HomePage;
